import { processSteps } from "@/mocks/homeData";

export default function Process() {
  return (
    <section id="proceso" className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-bold tracking-wide uppercase mb-4">
            Cómo trabajamos
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            Proceso simple, resultados garantizados
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed">
            Desde la primera consulta hasta el soporte postventa, te acompañamos en
            cada paso. Sin sorpresas, sin complicaciones.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {processSteps.map((step, i) => (
            <div
              key={step.step}
              className="reveal relative bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70 hover:border-primary-300/60 hover:shadow-lg hover:shadow-primary-100/50 transition-all duration-300 group"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Step number badge */}
              <div className="absolute -top-3 -right-3 w-10 h-10 rounded-full bg-accent-500 text-background-50 flex items-center justify-center font-heading font-bold text-sm shadow-lg shadow-accent-500/20 group-hover:scale-110 transition-transform">
                {step.step}
              </div>

              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${step.icon} text-primary-600 text-xl`} />
              </div>

              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {step.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}